module.exports = __webpack_public_path__ + "static/media/omsz_logo_374x135.29072815.png";